<template>
  <div>

    <v-form ref="inputForm" @submit.prevent="">

      <div v-html="$let('OtherPreferencesDisclaimer')" class="mb-10 subtitle-enquiry"></div>

      <v-row>
        <v-col cols="12" md="6">
          <YesNo
            v-model="model.signUPForOnlineAccess"
            v-if="elsInUse.SignUPForOnlineAccess"
            :label="elsLabel.SignUPForOnlineAccess"
            :helperText="elsHelperText.SignUPForOnlineAccess"
            :yesText="$let('ConfirmationYesLabelDefault')"
            :noText="$let('ConfirmationNoLabelDefault')"
            :rules="[elsRequired.SignUPForOnlineAccess ? rules.required : true]">
          </YesNo>
        </v-col>
        <v-col cols="12" md="6">
          <YesNo
            v-model="model.preferElectronicStatement"
            v-if="elsInUse.PreferElectronicStatement"
            :label="elsLabel.PreferElectronicStatement"
            :helperText="elsHelperText.PreferElectronicStatement"
            :yesText="$let('ConfirmationYesLabelDefault')"
            :noText="$let('ConfirmationNoLabelDefault')"
            :rules="[elsRequired.PreferElectronicStatement ? rules.required : true]">
          </YesNo>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <YesNo
            v-model="model.preferElectronicAGMBooklet"
            v-if="elsInUse.PreferElectronicAGMBooklet"
            :label="elsLabel.PreferElectronicAGMBooklet"
            :helperText="elsHelperText.PreferElectronicAGMBooklet"
            :yesText="$let('ConfirmationYesLabelDefault')"
            :noText="$let('ConfirmationNoLabelDefault')"
            :rules="[elsRequired.PreferElectronicAGMBooklet ? rules.required : true]">
          </YesNo>
        </v-col>
        <v-col cols="12" md="6"></v-col>
      </v-row>
      
      <StepperButtons 
        @continueClick="_stepperContinue"
        @backClick="_stepperBack">
      </StepperButtons>

    </v-form>

  </div>
</template>

<script>

  import { mapGetters } from "vuex";
  import StepperButtons from './stepper-buttons.vue'
  import YesNo from '@/shared/components/yes-no.vue'
  import opmGeneric from '../utils/generic.js';

  export default {
    name: 'OtherPreferences',
    components: { 
      StepperButtons,
      YesNo 
    },
    props: {
      rules: { type: Object },
    }, 
    emits: ["continueClick", "backClick"],
    data() {
      return {
        model: {
          signUPForOnlineAccess: undefined,
          preferElectronicStatement: undefined,
          preferElectronicAGMBooklet: undefined,
        }
      };
    },
    created() { 
      opmGeneric.setElementsConfig(this, this.elementsConfig); 
    },
    methods: {
      _stepperContinue() { 
        this.$emit("continueClick", this.model, this.$refs.inputForm); 
      },
      _stepperBack() { 
        this.$emit("backClick"); 
      },    
    },
    computed: {
      ...mapGetters(["elementsConfig"]),
    }    
  };
</script>

<style lang="scss" scoped>

</style>